import React, { useState } from 'react';

const Twentysixtheme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Neon Night */
            --bg-dark: #000000;
            --neon-blue: #06b6d4;  /* Cyan */
            --neon-pink: #d946ef;  /* Fuchsia */
            --text-main: #ffffff;
            --glass: rgba(255, 255, 255, 0.1);
        }

        body { font-family: 'Exo 2', sans-serif; background: var(--bg-dark); color: var(--text-main); margin: 0; }
        a { text-decoration: none; color: inherit; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { padding: 20px 0; border-bottom: 2px solid var(--neon-blue); box-shadow: 0 0 20px var(--neon-blue); }
        .nav-inner { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 2rem; font-weight: 900; color: var(--neon-pink); text-shadow: 2px 2px 0 var(--neon-blue); }
        .nav-links a { margin-left: 20px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
        .nav-links a:hover { color: var(--neon-pink); text-shadow: 0 0 10px var(--neon-pink); }
        
        .hero { padding: 120px 0; text-align: center; }
        .hero h1 { font-size: 4rem; text-transform: uppercase; margin-bottom: 20px; background: linear-gradient(90deg, var(--neon-blue), var(--neon-pink)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .btn { background: transparent; color: white; border: 2px solid var(--neon-blue); padding: 15px 40px; font-weight: 700; text-transform: uppercase; cursor: pointer; transition: 0.3s; position: relative; overflow: hidden; }
        .btn:hover { background: var(--neon-blue); box-shadow: 0 0 20px var(--neon-blue); color: black; }
        
        .section-title { font-size: 3rem; text-align: center; margin: 80px 0 50px; text-transform: uppercase; letter-spacing: 2px; border-bottom: 1px solid var(--glass); display: inline-block; padding-bottom: 10px; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 30px; }
        .card { background: var(--glass); border: 1px solid var(--glass); padding: 30px; border-radius: 10px; backdrop-filter: blur(10px); transition: 0.3s; }
        .card:hover { border-color: var(--neon-pink); box-shadow: 0 0 20px rgba(217, 70, 239, 0.3); }
        
        .product-img { width: 100%; height: 220px; object-fit: cover; border-radius: 5px; margin-bottom: 15px; opacity: 0.8; }
        .card:hover .product-img { opacity: 1; }
        
        .footer { padding: 50px 0; text-align: center; border-top: 1px solid var(--glass); margin-top: 100px; color: #888; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Exo+2:wght@400;700;900&display=swap" rel="stylesheet" />

            <nav className="navbar">
                <div className="container nav-inner">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

            <header className="hero">
                <div className="container">
                    <h1>Future is Now.</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '40px', color: '#ccc'}}>Cutting-edge solutions for the modern world.</p>
                    <a href="#products" className="btn">Get Access</a>
                </div>
            </header>
            
            <div className="container">
                <div style={{textAlign: 'center'}}><h2 className="section-title" id="services">Capabilities</h2></div>
                <div className="grid">
                     {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="card" key={index}>
                             <div style={{fontSize: '2.5rem', marginBottom: '15px'}}>
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px'}} alt=""/> : <span style={{color: 'var(--neon-blue)'}}>⚡</span>}
                             </div>
                             <h3 style={{fontSize: '1.5rem', color: 'var(--neon-blue)'}}>{item.name}</h3>
                             <p>{item.description}</p>
                        </div>
                     ))}
                </div>

                <div style={{textAlign: 'center'}}><h2 className="section-title" id="products">Inventory</h2></div>
                 <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index}>
                             <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>
                             <h3>{item.service_name}</h3>
                             {item.price && <div style={{color: 'var(--neon-pink)', fontWeight: 900, fontSize: '1.2rem', margin: '10px 0'}}>₹{item.price}</div>}
                             <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', fontSize: '0.8rem', padding: '10px 20px'}}>Add</button>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                 <h3>{get_data.service_name}</h3>
                 <p>{get_data.business_location_name}</p>
                 <p>&copy; {new Date().getFullYear()} Neon Systems</p>
            </footer>
        </>
    );
};

export default Twentysixtheme;
